export default class MmlApiClient {
	constructor(baseUrl, key) {
		this.baseUrl = baseUrl;
		this.apiKey = key;
	}

	synthesizeMusic(mml, instrument, signal) {
		const url = `${this.baseUrl}/api/synthesizeSoundFromMml?${new URLSearchParams({ mml, instrument })}`;
		return fetch(url, {
			withCredentials: true,
			credentials: 'include',
			signal,
			headers: {
				Authorization: this.apiKey,
			},
		}).then(r => r.arrayBuffer());
	}
}
